import React from "react"
import toast from "react-hot-toast"

// Estilos externos
import "react-s-alert/dist/s-alert-default.css"
import "react-s-alert/dist/s-alert-css-effects/scale.css"
import "react-s-alert/dist/s-alert-css-effects/genie.css"
import "react-s-alert/dist/s-alert-css-effects/jelly.css"

const CircularIcon = ({ type, size = 20 }) => {
  const iconStyles = {
    info: {
      backgroundColor: "#3b82f6",
      color: "#ffffff",
    },
    warning: {
      backgroundColor: "#f59e0b",
      color: "#ffffff",
    },
  }

  const iconSymbols = {
    info: "i",
    warning: "!",
  }

  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: size,
    height: size,
    borderRadius: "50%",
    padding: 8,
    fontSize: 13,
    fontWeight: 600,
    ...iconStyles[type],
  }

  return <span style={style}>{iconSymbols[type]}</span>
}

/**
 * Componente funcional
 * Utilizada a biblioteca (Alert) para definir a caixinha de alerta
 */
const Message = {
  /**
   * Método responsável por exibir a mensagem na tela
   * @param message           Mensagem a ser exibida
   * @param type              Tipo da mensagem
   * @param timeout           Tempo que a mensagem ficará na tela
   * @param position          Posição da mensagem na tela
   * @param effect            Efeito de exibição da mensagem
   */
  show(message, type = "error", timeout = 3000, position = "top-center") {
    const options = { position: position, duration: timeout }

    switch (type) {
      case "success":
        toast.success(message, {
          ...options,
          style: {
            backgroundColor: "#DCFCDE",
            color: "#4CAF50",
            border: "1px solid #4CAF50",
            fontSize: 13,
          },
        })
        break

      case "info":
        toast(message, {
          ...options,
          icon: <CircularIcon type={"info"} />,
          style: {
            backgroundColor: "#DCE7FA",
            color: "#448AFF",
            border: "1px solid #448AFF",
            fontSize: 13,
          },
        })
        break

      case "warning":
        toast(message, {
          ...options,
          icon: <CircularIcon type={"warning"} />,
          style: {
            backgroundColor: "#FCF2DF",
            color: "#FAB302",
            border: "1px solid #FAB302",
            fontSize: 13,
          },
        })
        break

      case "error":
        toast.error(message, {
          ...options,
          style: {
            backgroundColor: "#F8DBD8",
            color: "#F44335",
            border: "1px solid #F44335",
            fontSize: 13,
          },
        })
        break

      default:
        toast(message, options)
        break
    }
  },

  success(message) {
    this.show(message, "success")
  },

  info(message) {
    this.show(message, "info")
  },

  warning(message) {
    this.show(message, "warning")
  },

  error(message, error = null) {
    if (!!error) console.error(error)
    this.show(message, "error")
  },
}

export default Message
